// Italian provinces (107) + their cities (~7900). Data is fetched from
// /province-comuni.json (≈110 KB, compact ISTAT-sourced).
//
// Exposes a singleton loader so the dataset is fetched once per session.

let _cache = null;        // { provinceToCities, cityToProvince }
let _pending = null;      // in-flight fetch promise

export async function loadProvinces() {
    if (_cache) return _cache;
    if (_pending) return _pending;
    _pending = (async () => {
        try {
            const res = await fetch("/province-comuni.json");
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const provinceToCities = await res.json();
            const cityToProvince = {};
            for (const [prov, cities] of Object.entries(provinceToCities)) {
                for (const c of cities) cityToProvince[c] = prov;
            }
            _cache = { provinceToCities, cityToProvince };
            return _cache;
        } finally {
            _pending = null;
        }
    })();
    return _pending;
}

export function getProvinceForCity(city, cityToProvince) {
    if (!city || !cityToProvince) return null;
    return cityToProvince[city] || null;
}
